import { TranslationObject } from '../i18n/translation';

const namespace = 'practiceplaces';
const translations: TranslationObject = {
  title: {
    id: `${namespace}.title`,
    nb: 'Praksissteder',
    en: 'Practice places',
  },
  subtitle: {
    id: `${namespace}.subtitle`,
    nb: 'Her ser du en liste over alle praksisstedene du har en samarbeidsavtale med.',
    en: 'All practice places you have an agreement with.',
  },
  registerplace: {
    id: `${namespace}.registerplace`,
    nb: 'Registrer praksissted',
    en: 'Register practice place',
  },
  registeragreement: {
    id: `${namespace}.registeragreement`,
    nb: 'Registrer praksisavtale',
    en: 'Register practice agreement',
  },
  praksissted: {
    id: `${namespace}.praksissted`,
    nb: 'Praksissted',
    en: 'Practice place',
  },
  status: {
    id: `${namespace}.status`,
    nb: 'Status',
    en: 'Status',
  },
  handling: {
    id: `${namespace}.action`,
    nb: 'Handling',
    en: 'Action',
  },

  harTilgang: {
    id: `${namespace}.harTilgang`,
    nb: 'Har tilgang til Arbeidslivsportalen',
    en: 'Have access to Arbeidslivsportalen',
  },
  erInvitert: {
    id: `${namespace}.erInvitert`,
    nb: 'Bruker er invitert',
    en: 'User invited',
  },
  ikkeInvitert: {
    id: `${namespace}.ikkeInvitert`,
    nb: 'Ikke invitert',
    en: 'Not invited',
  },
  inviterNy: {
    id: `${namespace}.inviterNy`,
    nb: 'Inviter ny bruker',
    en: 'Invite new user',
  },
  inviterTilAlp: {
    id: `${namespace}.inviterTilAlp`,
    nb: 'Inviter til Arbeidslivsportalen',
    en: 'Invite to Arbeidslivsportalen',
  },
  tabAllePraksissteder: {
    id: `${namespace}.tabAllePraksissteder`,
    nb: 'Alle praksissteder',
    en: 'All practice places',
  },
  tabKontaktpersoner: {
    id: `${namespace}.tabKontaktpersoner`,
    nb: 'Kontaktpersoner',
    en: 'Contact person',
  },
  tabAvtaler: {
    id: `${namespace}.tabAvtaler`,
    nb: 'Avtaler',
    en: 'Agreements',
  },
  tabAvtaleutkast: {
    id: `${namespace}.tabAvtaleutkast`,
    nb: 'Avtaleutkast',
    en: 'Agreement drafts',
  },
};

export default translations;
